/* eslint-disable react/require-default-props */

/* eslint-disable no-const-assign */
import "emoji-mart/css/emoji-mart.css";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Input, message, Select, Skeleton, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { postSvixWebhook } from "../../lib/queries";
import { getSupaClient, getWorkspace } from "../../lib/supabase";
import {
  setActiveUsersData,
  setAllUsersData,
  setAtRiskUsersData,
  setNewUsersData,
  setTeamTagsData,
} from "../../redux/actions";
import { TAG_COLORS } from "../../utils/constants";

const { Option } = Select;

const MemberTags = (props) => {
  /** *
   *  props.memberId REQUIRED.
   *  Optional: memberTags along with OnTeamTagAdded and teamTags if you already have a list
   *  If only memberTags isnt provided this component will assume you want to pull the member tags and team tags in the compoennt itself
   */

  // props.memberId REQUIRED
  // props.onTeamTagAdded --> a callback in the parent component that will be invoked if a new team tag is added
  // props.onMemberTagAdded --> a callback in the parent component that will be invoked if a member tag is added
  // props.onMemberTagRemoved --> a callback in the parent component that will be invoked if a member tag is removed
  // props.teamTags
  // props.pullTags
  // props.teamId
  const supabase = getSupaClient();
  const workspace = getWorkspace(supabase);
  const platform = localStorage.getItem("platform");
  const teamId =
    platform === "slack"
      ? localStorage.getItem("team-id")
      : localStorage.getItem("guild-id");

  const [memberTags, setMemberTags] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [errors, setErrors] = useState(null);
  const [memberTagsId, setMemberTagsId] = useState([]);
  const [teamTags, setTeamTags] = useState([]);
  const dispatch = useDispatch();
  let updatedTags = useSelector((state) => state.teamTags.team_tags);
  const allUsers = useSelector((state) => state.users.all_users);
  const newUsers = useSelector((state) => state.users.new_users);
  const activeUsers = useSelector((state) => state.users.active_users);
  const atRiskUsers = useSelector((state) => state.users.at_risk_users);

  const loadTeamTags = async () => {
    let query = supabase.from("tags").select("id, name, color");
    if (platform === "slack") {
      query = query.eq("team", teamId);
    } else {
      query = query.eq("guild", teamId);
    }
    const { data, error } = await query;
    if (data) {
      setTeamTags(data);
    }
    if (error) {
      console.log("Error", error);
    }
  };

  const loadTags = async () => {
    loadTeamTags();
    // load user tags
    let query;
    if (platform === "slack") {
      query = supabase
        .from("slack_users")
        .select("tags(id, name, color)")
        .match({ slack_id: props.memberId });
    } else {
      query = supabase
        .from("discord_members")
        .select("tags(id, name, color)")
        .match({ id: props.memberId });
    }
    const { data, error } = await query;
    if (data && data[0].tags) {
      setMemberTags(data[0].tags);
      setMemberTagsId(data[0].tags.map((item) => item.id));
    }
    if (error) {
      message.info("Error loading tags. Please refresh");
    }
  };

  useEffect(() => {
    if (props.memberTags) {
      setMemberTags(props.memberTags);
      setMemberTagsId(props.memberTags.map((item) => item.id));
    } else {
      loadTags();
    }
  }, [props.memberTags, props.memberId]);

  const onTagNameChange = (event) => {
    event.preventDefault();
    setNewTag(event.target.value);
  };

  function returnTagObj(value) {
    if (props.memberTags) {
      return props.teamTags.find((item) => item.id === value);
    }
    return teamTags.find((item) => item.id === value);
  }

  function tagRender(payload) {
    const { onClose, closable, value } = payload;
    if (payload.value) {
      const memberTag = memberTags.find(
        (element) => element.id === payload.value
      );
      if (memberTag) {
        return (
          <Tag
            color={memberTag.color}
            closable={closable}
            onClose={onClose}
            style={{ marginRight: 3 }}
            key={value}
          >
            {memberTag.name}
          </Tag>
        );
      }
      return null;
    }
    return null;
  }

  const onSelect = async (selection) => {
    const selectedTag = returnTagObj(selection);
    const newMemberTags = memberTags.concat(selectedTag);
    setMemberTags(newMemberTags);
    setMemberTagsId(newMemberTags.map((item) => item.id));

    let insert = {};
    if (platform === "slack") {
      insert = {
        user_id: props.memberId,
        tag: selection,
        team: teamId,
        workspace,
      };
    } else if (platform === "discord") {
      insert = {
        discord_member_id: props.memberId,
        tag: selection,
        guild: teamId,
        workspace,
      };
    }

    window.analytics.track("User tag added");
    // send webhook request
    postSvixWebhook("slack_users.tag_added", new Date().getTime(), {
      slack_id: props.memberId,
      team: teamId,
      tag: selectedTag,
      email: props.member ? props.member.email : null,
      name: props.member ? props.member.name : null,
    });
    const updatedAllUsers = allUsers.map((item) => {
      if (item.key === props.memberId) {
        item = { ...item, tags: [...item.tags, selectedTag] };
      }
      return item;
    });
    dispatch(setAllUsersData(updatedAllUsers));

    const updatedNewUsers = newUsers.map((item) => {
      if (item.key === props.memberId) {
        if (item.tags !== null) {
          item = { ...item, tags: [...item.tags, selectedTag] };
        } else {
          item = { ...item, tags: [selectedTag] };
        }
      }
      return item;
    });
    dispatch(setNewUsersData(updatedNewUsers));

    const updatedActiveUsers = activeUsers.map((item) => {
      if (item.key === props.memberId) {
        if (item.tags !== null) {
          item = { ...item, tags: [...item.tags, selectedTag] };
        } else {
          item = { ...item, tags: [selectedTag] };
        }
      }
      return item;
    });
    dispatch(setActiveUsersData(updatedActiveUsers));

    const updatedAtRiskUsers = atRiskUsers.map((item) => {
      if (item.key === props.memberId) {
        if (item.tags !== null) {
          item = { ...item, tags: [...item.tags, selectedTag] };
        } else {
          item = { ...item, tags: [selectedTag] };
        }
      }
      return item;
    });
    dispatch(setAtRiskUsersData(updatedAtRiskUsers));
    // call upstream func
    if (props.onMemberTagAdded) {
      await props.onMemberTagAdded(props.memberId, selectedTag);
    }
    if (props.onCompanyMemberTagAdded) {
      props.onCompanyMemberTagAdded(selectedTag);
    }
    const table = platform === "slack" ? "user_tags" : "discord_user_tags";
    const { data, error } = await supabase.from(table).insert(insert);

    if (error) {
      message.warning(
        `Error adding tag ${selectedTag.name}. Please try again or refresh the page.`
      );
      const fixedTags = memberTags.filter((t) => t.id !== selectedTag.id);
      const fixedTagIds = memberTagsId.filter((t) => t !== selectedTag.id);
      setMemberTags(fixedTags);
      setMemberTagsId(fixedTagIds);
      window.analytics.track("User tag adding error");
    }
  };

  const onDeselect = async (selection) => {
    const selectedTag = returnTagObj(selection);
    // delete tag from db
    const match = { tag: selection };
    if (platform === "slack") {
      match.user_id = props.memberId;
    } else if (platform === "discord") {
      match.discord_member_id = props.memberId;
    }
    // send webhook request
    postSvixWebhook("slack_users.tag_removed", new Date().getTime(), {
      slack_id: props.memberId,
      team: teamId,
      tag: selectedTag,
      email: props.member ? props.member.email : null,
      name: props.member ? props.member.name : null,
    });
    const updatedAllUsers = allUsers.map((item) => {
      if (item.key === props.memberId) {
        const updatedTagsArray = item.tags.filter(
          (tag) => tag.id !== selection
        );
        item = { ...item, tags: updatedTagsArray };
      }
      return item;
    });
    dispatch(setAllUsersData(updatedAllUsers));

    const updatedNewUsers = newUsers.map((item) => {
      if (item.key === props.memberId) {
        const updatedTagsArray = item.tags.filter(
          (tag) => tag.id !== selection
        );
        item = { ...item, tags: updatedTagsArray };
      }
      return item;
    });
    dispatch(setNewUsersData(updatedNewUsers));

    const updatedActiveUsers = activeUsers.map((item) => {
      if (item.key === props.memberId) {
        const updatedTagsArray = item.tags.filter(
          (tag) => tag.id !== selection
        );
        item = { ...item, tags: updatedTagsArray };
      }
      return item;
    });
    dispatch(setActiveUsersData(updatedActiveUsers));

    const updatedAtRiskUsers = atRiskUsers.map((item) => {
      if (item.key === props.memberId) {
        const updatedTagsArray = item.tags.filter(
          (tag) => tag.id !== selection
        );
        item = { ...item, tags: updatedTagsArray };
      }
      return item;
    });
    dispatch(setAtRiskUsersData(updatedAtRiskUsers));

    const remainingTags = memberTags.filter((tag) => tag.id !== selection);
    setMemberTags(remainingTags);
    setMemberTagsId(remainingTags.map((item) => item.id));
    if (props.onMemberTagRemoved) {
      await props.onMemberTagRemoved(props.memberId, selectedTag);
    }
    if (props.onCompanyMemberTagRemoved) {
      await props.onCompanyMemberTagRemoved(selection);
    }
    const table = platform === "slack" ? "user_tags" : "discord_user_tags";
    const { data, error } = await supabase.from(table).delete().match(match);
    window.analytics.track("User tag removed");
    if (error) {
      console.log("onDeselect", error);
      message.warning("Error removing tag. Please try again");
      window.analytics.track("User tag remove error");
    }
  };

  const getNewTagColor = () => {
    let tagColor = "";
    if (props.memberTags) {
      if (props.teamTags.length < TAG_COLORS.length) {
        tagColor = TAG_COLORS[props.teamTags.length];
      } else {
        tagColor = TAG_COLORS[teamTags.length % TAG_COLORS.length];
      }
    } else if (teamTags.length < TAG_COLORS.length) {
      tagColor = TAG_COLORS[teamTags.length];
    } else {
      tagColor = TAG_COLORS[teamTags.length % TAG_COLORS.length];
    }
    return tagColor;
  };

  /**
   * Checks if tag is an empty string
   *
   * @param {*} tag: string - The tag to check
   * @returns  whether the tag is an empty string or not
   */
  const checkEmptyTag = (tag) => {
    const parsedTag = tag.split(" ").filter((item) => item);
    return parsedTag.length > 0;
  };

  const addItem = async () => {
    const tagColor = getNewTagColor();
    const parsedTag = checkEmptyTag(newTag);
    if (parsedTag) {
      const insertTag = {
        name: newTag,
        color: tagColor,
        workspace,
      };
      if (platform === "slack") {
        insertTag.team = teamId;
      } else {
        insertTag.guild = teamId;
      }
      const { data, error } = await supabase.from("tags").insert([insertTag]);

      if (data) {
        console.log("adding", data);
        updatedTags = [...updatedTags, ...data];
        dispatch(setTeamTagsData(updatedTags));

        window.analytics.track("New team tag added");
        if (props.onTeamTagAdded) {
          await props.onTeamTagAdded(data[0]);
        } else {
          setTeamTags(
            teamTags.concat({
              id: data[0].id,
              name: data[0].name,
              color: data[0].color,
            })
          );
        }
        const userTagInsert = {
          tag: data[0].id,
          workspace,
        };
        if (platform === "slack") {
          userTagInsert.team = teamId;
          userTagInsert.user_id = props.memberId;
        } else {
          userTagInsert.guild = teamId;
          userTagInsert.discord_member_id = props.memberId;
        }
        const table = platform === "slack" ? "user_tags" : "discord_user_tags";
        await supabase.from(table).insert(userTagInsert);
        const newMemberTags = memberTags.concat(data[0]);
        setMemberTags(newMemberTags);
        setMemberTagsId(newMemberTags.map((item) => item.id));
        if (props.onMemberTagAdded) {
          await props.onMemberTagAdded(props.memberId, data[0]);
        }
        setNewTag("");
        setErrors();
      }
      if (error) {
        setErrors({ teamTag: true });
        window.analytics.track("Team tag error");
      }
    }
  };

  if (!props.memberId) {
    return <Skeleton active />;
  }

  return (
    <>
      <Select
        mode="multiple"
        showArrow
        tagRender={tagRender}
        value={memberTagsId}
        style={{ width: "100%", borderRadius: 10 }}
        onSelect={onSelect}
        onDeselect={onDeselect}
        optionFilterProp="name"
        dropdownRender={(menu) => (
          <div>
            {menu}
            <Divider style={{ margin: "4px 0" }} />
            <div
              style={{
                display: "flex",
                flexWrap: "nowrap",
                padding: 8,
              }}
            >
              <Input
                style={{ flex: "auto", borderRadius: 5 }}
                value={newTag}
                onChange={onTagNameChange}
                onKeyDown={(e) => e.stopPropagation()}
              />
              <div className="pl-2">
                <Button
                  type="primary"
                  style={{
                    flex: "none",
                    display: "block",
                    cursor: "pointer",
                  }}
                  onClick={addItem}
                  disabled={newTag === ""}
                >
                  + New tag
                </Button>
              </div>
            </div>
            {errors && errors.teamTag ? (
              <p>Error adding tag, try again please</p>
            ) : (
              ""
            )}
          </div>
        )}
      >
        {props.memberTags
          ? props.teamTags.map((item) => {
              return (
                <Option key={item.id} value={item.id} name={item.name}>
                  <Tag
                    style={{
                      border: `0.5px solid ${item.color}`,
                      borderRadius: 5,
                      borderWidth: "thin",
                      width: "fit-content",
                    }}
                  >
                    {item.name}
                  </Tag>
                </Option>
              );
            })
          : teamTags.map((item) => {
              return (
                <Option key={item.id} value={item.id} name={item.name}>
                  <Tag
                    style={{
                      border: `0.5px solid ${item.color}`,
                      borderRadius: 5,
                      borderWidth: "thin",
                      width: "fit-content",
                    }}
                  >
                    {item.name}
                  </Tag>
                </Option>
              );
            })}
      </Select>
    </>
  );
};

export default MemberTags;
